
import { startOfDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

import useLocale from '../useLocale';

export interface DateRangeProps {
  start: string | null;
  end?: string | null;
  timezone?: string | null;
}

/**
 * @param start UTC start date.
 * @param end UTC end date.
 */
const DateRange = ({ start, end, timezone: timezoneProp }: DateRangeProps) => {
  const { parseDate, formatDate, locale, timezone: defaultTimezone } = useLocale();

  const timezone = timezoneProp || defaultTimezone;

  const startDate = startOfDay(toZonedTime(parseDate(start, { timezone: 'UTC' }), timezone));
  const endDate = startOfDay(toZonedTime(parseDate(end || start, { timezone: 'UTC' }), timezone));

  if (startDate.getTime() === endDate.getTime()) {
    return (
      <>
        {formatDate(startDate, { format: 'display_date', timezone: null })}
      </>
    );
  }

  try {
    const formatted = new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric', // @ts-ignore-next-line
    }).formatRange(startDate, endDate);

    return <>{formatted}</>;
  } catch {
    return (
      <>
        {formatDate(startDate, { format: 'display_date', timezone: null })}
        {' - '}
        {formatDate(endDate, { format: 'display_date', timezone: null })}
      </>
    );
  }
};

export default DateRange;
